var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-body"},[_c('vue-markdown',{attrs:{"source":_vm.content,"linkify":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }